import React from 'react';
import { createRoot } from 'react-dom/client';

import { CountryExchangeTool } from '../main-app/components/DemarchesPermis/components/CountryExchangeTool';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-country-exchange-tool');

  if (!node) {
    return;
  }

  const root = createRoot(node);
  root.render(<CountryExchangeTool />);
});
